import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';
import fire from '../firebase/firebase';
import PhoneNumber from 'react-phone-number';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: null,
     };
  }

  componentDidMount() {
    let phoneNumber = fire.database().ref('phone-number');
    phoneNumber.on('value', snapshot => {
      this.setState({phoneNumber: snapshot.val()});
    });
  }

  render() {
    return (
      <div className="contact-block">
        <div className="parallax__short"></div>
        <div className="app-content main-content">
          <ScrollableAnchor id="contact">
            <div className="block__content" id="contactus">
                <div className="contact-block__content contact-block__content--split">
                    <h1>Contact us</h1>
                </div>
                <div className="contact-block__content contact-block__content--split">
                    <p>call us now on:</p>
                    <h2><PhoneNumber number={this.state.phoneNumber} isLinked={true} /></h2>
                    <p>or</p>
                    <p><a href='mailto:enquiries@eitx.co.uk' title='email us at enquiries@eitx.co.uk'>email us at enquiries@eitx.co.uk</a></p>
                </div>
            </div>
          </ScrollableAnchor>
        </div>
      </div>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/shared/contact.js